import { render, staticRenderFns } from "./RecordNew.vue?vue&type=template&id=462df9c6"
import script from "./RecordNew.vue?vue&type=script&lang=js"
export * from "./RecordNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports